import React from 'react'
import ReactMarkdown from 'react-markdown'

import s from './MdContentRenderer.module.scss'

export type MdContentRendererProps = {
  content: string
}

export const MdContentRenderer: React.FC<MdContentRendererProps> = ({
  content,
}) => {
  return (
    <div className={s.MdContentRenderer}>
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  )
}
